import {_CONST} from '@/constants/constants';

const LS_KEY = _CONST.lsKey;

const getEnvStorage = () => {
  return __env.useSS ? sessionStorage : localStorage
}

export const LS = {
    get(key) {
        const value = localStorage.getItem(LS_KEY + key);

        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    },
    set(key, value) {
        localStorage.setItem(LS_KEY + key, JSON.stringify(value));
    }
}

export const SS = {
    get(key) {
        const value = sessionStorage.getItem(LS_KEY + key);

        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    },
    set(key, value) {
        sessionStorage.setItem(LS_KEY + key, JSON.stringify(value));
    }
}

export const ES = {
    get(key) {
        const value = getEnvStorage().getItem(LS_KEY + key);

        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    },
    set(key, value) {
      getEnvStorage().setItem(LS_KEY + key, JSON.stringify(value));
    }
}
